export const SERVER_ERROR_CODES = {
  UNVERIFIED_MODEL_NOT_APPROVED: 1076,
  EMAIL_DOMAIN_UNAUTHORIZED_TO_SIGN_IN: 1077,
  EMAIL_MISMATCH_ERROR_CODE: 1015,
  EMAIL_PASSWORD_LOGIN_NOT_ALLOWED: 1082,
  DUPLICATE_CUSTOM_FONT: 1083,
  TURNSTILE_VERIFICATION_FAILED: 1133,
  // KEEP_IN_SYNC weavy/core/src/shared/exceptions/app-error-codes.enum.ts (AppInternalErrorCode)
  TIER_COOKIE_MISMATCH: 1139,
  FIGMA_NODE_NOT_CONNECTED: 1114,
  TOOL_PUBLISH_UNAVAILABLE_MODELS: 1192,
  RATE_LIMITED: 1205,
  MOVE_TO_PERSONAL_NOT_OWNER: 1211,
  COMMENT_MENTION_SHARE_REQUIRED: 1212,
};
